import {
  BusinessColId,
  LivestockSaleColumnDefinitions,
} from "constants/columnDefinitions";
import { LivestockSaleColId } from "constants/columns";
import { ACTION_COLUMN_NAME } from "constants/aggrid";
import { LivestockSaleActionsColumnRenderer } from "lib/agGrid/renderers/livestockSale";
import { ColDef } from "ag-grid-community";
import { LivestockSaleAgGridRowType } from "selectors/aggrid/sales";

export const columnDefs: ColDef<LivestockSaleAgGridRowType>[] = [
  LivestockSaleColumnDefinitions[LivestockSaleColId.DATE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_CODE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_SUB_TYPE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALE_TYPE],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SALEYARD],
  LivestockSaleColumnDefinitions[LivestockSaleColId.SPECIES_NAME],
  LivestockSaleColumnDefinitions[LivestockSaleColId.TITLE],

  {
    headerName: ACTION_COLUMN_NAME,
    colId: BusinessColId.ACTIONS,
    field: "livestockSale.id",
    pinned: "right",
    cellRenderer: LivestockSaleActionsColumnRenderer,
    width: 140,
  },
];

export const agentColumnDefs = [
  ...columnDefs,
  LivestockSaleColumnDefinitions[LivestockSaleColId.STATUS],
  LivestockSaleColumnDefinitions[LivestockSaleColId.COMMENTS],
];
